import React, { ReactNode } from "react";

import styles from "./app-container.module.css";

interface AppContainerProps {
  children?: ReactNode;
}

function AppContainer({ children }: AppContainerProps) {
  return <main className={styles.appContainer}>{children}</main>;
}

export default AppContainer;
